app.controller(
    'AdminCityListController', ['$scope', '$rootScope', '$stateParams', 'UserService', '$translate', 'AdminService', 'toastr', AdminCityListController]
);

function AdminCityListController($scope, $rootScope, $stateParams, UserService, $translate, AdminService, toastr) {
    $scope.selectedItem = null;


    $translate.use($rootScope.LangForInterface);

    var vm = this;
    vm.modalObject = {};
    vm.ZoneList = []; 
    vm.pageno = 1; // initialize page no to 1
    vm.total_count = 0;
    vm.sortKey = "ZoneTitle";
    vm.direction = "ascending";
    vm.reverse = false,
    vm.itemsPerPage = 10; //this could be a dynamic value from a drop down
    vm.getData = function (pageno, sortKey, reverse) { // This would fetch the data on page change.
        //In practice this should be in a factory.
        vm.ZoneList = [];
        //Get List 
        var promiseGetList = UserService.GetZoneList(vm.itemsPerPage, pageno, sortKey, reverse, $rootScope.LangForWork);
        promiseGetList.then(function (response) {
            vm.ZoneList = response.data.ZoneList;  // data to be displayed on current page.
            vm.total_count = response.data.total_count; // total data count.
        });
    };
    vm.getData(vm.pageno, vm.sortKey, vm.reverse); // Call the function to fetch initial data on page load.

    if ($rootScope.RedirectFromZoneCreation == true) {
        toastr.success('Nous vous confirmons que votre action est bien enregistrée');
        $rootScope.RedirectFromZoneCreation = false;
    }

    $scope.vm = vm;

    $scope.sort = function (keyname) {
        vm.sortKey = keyname;   //set the sortKey to the param passed
        vm.reverse = !vm.reverse; //if true make it false and vice versa
        vm.getData(vm.pageno, keyname, vm.reverse);
    }

    vm.getUserUrl = function (zoneId, lang) {
        var urlDynamique = '/#!/admin/city/info?z=';        
        
        return $rootScope.interfaceSubFolder + urlDynamique + zoneId + "&lang=" + lang;
    }

    $scope.showOptions = function(item, $event)
    {
        $event.stopPropagation();
        $scope.selectedItem = $scope.selectedItem == item ? null : item;
    };

    $scope.close = function(){
        $scope.selectedItem = null;
    };

    vm.DeleteZone = function (zone) {
        AdminService.DeleteZone(zone)
       .then(
               function success(data) {
                   location.reload();
               },
               function error(data) { });


    }

    vm.ShowDeleteConfirmation = function (zone) {
        vm.modalObject.zone = zone;
        $scope.modalDelete = true;
        $event.stopPropagation();
    };

    vm.DeleteZoneFromConfirmation = function () {
        vm.DeleteZone(vm.modalObject.zone);
        $scope.modalDelete = false;
    };
}